import styled from 'styled-components';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

import {
  portage0,
  portage20,
  firefly_2,
} from '@paradigm/design-system/src/colors';
import HiddenOrders from './HiddenOrders';
import ScreenPrice from './ScreenPrice';

const ScreenPriceAndHiddenOrderContainer = () => {
  return (
    <Container>
      <HiddenOrders data-testid="drfq-view-details-my-bids" />
      <Divider />
      <ScreenPrice data-testid="drfq-view-details-screen-prices" />
    </Container>
  );
};

const Container = styled.div`
  margin-left: 16px;
  border-radius: 3px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr 140px;
  width: 100%;
  min-height: 32px;
  align-items: center;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    display: block;
    padding: 0.5rem;
  }
`;

const SideArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-right: 1em;
  border: 0;
`;

const CenterArea = styled.div`
  display: grid;
  grid-template-columns: 60px 20px 120px 1fr 120px 60px 20px;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-right: 16px;
  background-color: ${firefly_2};
`;

const BaseCell = styled.div`
  line-height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
`;

const PriceCell = styled(BaseCell)`
  border-radius: 2px;
  color: white;
  padding: 0 8px;
  min-width: 80px;
  font-family: monospace;
`;

const QuantityCell = styled(BaseCell)`
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.75rem;
  width: 40px;
`;

const Space = styled.div`
  width: 100%;
  height: 100%;
`;

const Title = styled.p`
  margin: 0;
  opacity: 0.7;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 16px;
  text-align: left;
  font-weight: 500;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 0.875rem;
  }
`;

const SubTitle = styled(Title)`
  opacity: 0.5;
  font-size: 10px;
  font-weight: normal;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 0.75rem;
  }
`;

const Divider = styled.div`
  background-color: ${firefly_2};
  background: linear-gradient(to right, ${portage0}, ${portage20}, ${portage0});
  height: 2px;
  margin: 0 140px 0 140px;
`;

export {
  ScreenPriceAndHiddenOrderContainer,
  Row,
  SideArea,
  CenterArea,
  Space,
  Title,
  SubTitle,
  PriceCell,
  QuantityCell,
};
